"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

require("core-js/modules/es.json.stringify.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.array.join.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

var _message = require("@/components/dialog/message.js");

var _commonMixin = _interopRequireDefault(require("@/components/common/commonMixin.vue"));

var _settings = require("@/model/settings");

var _NoData = _interopRequireDefault(require("@/components/common/NoData"));

var _vuex = require("vuex");

var _getAssetsCoin = require("../ucenter/common/getAssetsCoin");

var _index = require("@/model/assets/index");

var _qrcode = _interopRequireDefault(require("qrcode.vue"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  mixins: [_commonMixin.default],
  components: {
    NoData: _NoData.default,
    QrcodeVue: _qrcode.default
  },
  data: function data() {
    return {
      isScroll: false,
      createVisible: false,
      modifyVisible: false,
      delVisible: false,
      modifyLoading: false,
      delLoading: false,
      creatLoading: false,
      pageLoading: true,
      coinData: {},
      addressData: {
        address: "",
        bak: "",
        qrcode_url: "",
        transactions: "",
        chain_tag: "",
        ua_id: ""
      },
      chain_tag: "erc20",
      bak: "",
      new_bak: "",
      addressActive: "",
      coinMaps: {},
      addressList4Tag: {},
      time: "",
      active: "",
      chainMap: {},
      item_id: "10007",
      acitiveChain: "0",
      data: {
        itemDetail: {
          coin_url: ""
        }
      },
      coinInfo: [],
      chainList: [{
        address: "",
        qrcode_url: ""
      }],
      qrcodeList: [],
      addressList: []
    };
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)({
    language: "user/language"
  })), {}, {
    confirmNum: function confirmNum() {
      if (JSON.stringify(this.data) !== "{}") {
        var confirm_num = this.data.itemDetail.confirm_num;
        return confirm_num;
      } else {
        return "--";
      }
    },
    coinInfoComputed: function coinInfoComputed() {
      var tempObj = [];

      for (var key in this.coinInfo) {
        if (this.data.itemDetail.coin_id == this.coinInfo[key].value) {
          tempObj.push({
            key: this.coinInfo[key].value,
            value: this.coinInfo[key].label,
            label: this.coinInfo[key].label.toUpperCase()
          });
        }
      } // if (tempObj.length > 0) {
      //   this.chain_tag = tempObj[0].label;
      // } else {
      //   this.chain_tag = this.data.itemDetail.default_chain.toUpperCase();
      // }


      var erc20 = {};
      var trc20 = {};
      tempObj.forEach(function (ele) {
        if (ele.label === "ERC20") erc20 = ele;
        if (ele.label === "TRC20") trc20 = ele;
      });
      var newtempObj = tempObj.filter(function (ele) {
        return ele.label != "ERC20" && ele.label != "TRC20";
      });

      if (JSON.stringify(erc20) != "{}") {
        newtempObj.push(erc20);
      }

      if (JSON.stringify(trc20) != "{}") {
        newtempObj.unshift(trc20);
      }

      return newtempObj;
    }
  }),
  created: function created() {
    var _this = this;

    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var item, key, _key;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _getAssetsCoin.getCurrentCoin)();

            case 2:
              _this.data = _context.sent;
              _context.next = 5;
              return _this.getStaticChainInfo();

            case 5:
              _context.next = 7;
              return (0, _getAssetsCoin.getCoinInfo)();

            case 7:
              _this.coinData = _context.sent;

              for (item in _this.coinData) {
                _this.coinData[item].capital_name = _this.coinData[item].itemDetail.capital_name; // this.coinData[item].language = this.coinData[item].itemDetail.language[
                //   "display_" + this.language
                // ];

                for (key in _this.coinMaps) {
                  if (_this.coinData[item].item_tag == _this.coinMaps[key].coin_id) {
                    _this.coinData[item].language = _this.coinMaps[key].language;
                  }
                }
              }

              for (_key in _this.coinData) {
                if (_this.coinData[_key].item_name == "usdt") {
                  _this.data = _this.coinData[_key];
                }
              }

              console.log(_this.coinData);

              _this.selectChange(_this.item_id);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  beforeDestroy: function beforeDestroy() {},
  destroyed: function destroyed() {},
  methods: {
    //新增确认
    onCreateConfirm: function onCreateConfirm() {
      var _this2 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var req, _yield$apiCreateFinan, status, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this2.bak) {
                  _context2.next = 13;
                  break;
                }

                _this2.creatLoading = true;
                req = {
                  item_id: _this2.data.item_id,
                  bak: _this2.bak
                }; // if (!this.data.itemDetail.multi_chain_status) {
                //   this.active = "";
                // } else {
                //   req.chain_tag = this.chain_tag;
                // }

                req.chain_tag = _this2.chain_tag;
                _context2.next = 6;
                return (0, _index.apiCreateFinanceAddress)(req);

              case 6:
                _yield$apiCreateFinan = _context2.sent;
                status = _yield$apiCreateFinan.status;
                data = _yield$apiCreateFinan.data;
                _this2.creatLoading = false;

                if (status == 200) {
                  (0, _message.showMessage)({
                    message: _this2.translateTitle("\u751F\u6210\u65B0\u5145\u5E01\u5730\u5740\u6210\u529F"),
                    type: "success"
                  });

                  _this2.getAddress(_this2.chain_tag);

                  _this2.bak = "";
                  _this2.createVisible = false;
                }

                _context2.next = 14;
                break;

              case 13:
                (0, _message.showMessage)({
                  message: _this2.translateTitle("\u8BF7\u8F93\u5165\u65B0\u5730\u5740\u5907\u6CE8\u540D"),
                  type: "error"
                });

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    scrollAdress: function scrollAdress() {
      this.isScroll = true;
    },
    getScrollClass: function getScrollClass() {
      var tempVal = "";

      if (this.addressList.length > 6) {
        tempVal = "scroll-calss";
      } else {
        tempVal = "";
      }

      return tempVal;
    },
    onAddressChange: function onAddressChange(val) {
      var _this3 = this;

      //   this.$refs.scorllRef.scrollTo(0,0)
      // //   window.scrollTo(0,0);   // chrome
      // // document.body.scrollTop = 0
      this.addressActive = val;
      this.addressList.forEach(function (item) {
        if (val == item.ua_id) {
          _this3.addressData = item;
          _this3.ua_id = val;
        }
      });
    },
    onModifyClose: function onModifyClose() {
      this.new_bak = "";
    },
    onCreate: function onCreate() {
      this.createVisible = true;
      this.time = parseInt(new Date().getTime() / 1000);
      this.bak = this.translateTitle("\u65B0\u5730\u5740") + this.time;
      this.isModify = false;
    },
    // 选项卡切换
    onTypeChange: function onTypeChange(val) {
      this.isModify = false;
      this.chain_tag = val; // this.getAddress(val);

      this.onChangeTag(val);
    },
    //切换链选项卡
    onChangeTag: function onChangeTag(tagName) {
      this.active = tagName.toUpperCase();
      this.addressList = this.addressList4Tag[tagName.toLowerCase()]; // this.addressList = data;  //pangpang注释
      // this.addressOptions = data; //pangpang注释

      if (!this.isModify) {
        if (this.addressList4Tag[tagName.toLowerCase()].length > 0) {
          this.addressData = this.addressList4Tag[tagName.toLowerCase()][0];
          this.ua_id = this.addressData.ua_id;
          this.addressActive = this.addressData.ua_id; // this.onAddressChange(this.ua_id);
        } else {
          this.addressList = [];
          this.addressData = [];
        }
      } else {
        this.onAddressChange(this.ua_id);
      }
    },
    onFilterNewBak: function onFilterNewBak(val) {
      this.new_bak = val.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\$]/g, "");
    },
    onFilterBak: function onFilterBak(val) {
      this.bak = val.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\$]/g, "");
    },
    mainClose: function mainClose() {
      this.isModify = false; // this.chain_tag = "erc20";
    },
    //修改确认
    onModifyConfirm: function onModifyConfirm() {
      var _this4 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var req, _yield$apiSaveFinance, status, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_this4.new_bak) {
                  _context3.next = 17;
                  break;
                }

                if (!(_this4.new_bak == _this4.addressData.bak)) {
                  _context3.next = 6;
                  break;
                }

                _this4.modifyVisible = false;
                return _context3.abrupt("return");

              case 6:
                req = {
                  ua_id: _this4.ua_id,
                  bak: _this4.new_bak
                };
                _this4.modifyLoading = true;
                _context3.next = 10;
                return (0, _index.apiSaveFinanceAddress)(req);

              case 10:
                _yield$apiSaveFinance = _context3.sent;
                status = _yield$apiSaveFinance.status;
                data = _yield$apiSaveFinance.data;
                _this4.modifyLoading = false;

                if (status == 200) {
                  (0, _message.showMessage)({
                    message: _this4.translateTitle("\u4FEE\u6539\u6210\u529F"),
                    type: "success"
                  });

                  _this4.getAddress(_this4.chain_tag);

                  _this4.new_bak = "";
                  _this4.isModify = true;
                  _this4.modifyVisible = false;
                }

              case 15:
                _context3.next = 18;
                break;

              case 17:
                (0, _message.showMessage)({
                  message: _this4.translateTitle("\u8BF7\u8F93\u5165\u65B0\u5907\u6CE8\u540D"),
                  type: "error"
                });

              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    //删除确认
    onDeleteConfirm: function onDeleteConfirm() {
      var _this5 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var req, _yield$apiDelFinanceA, status, data;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.delLoading = true;
                req = {
                  ua_id: _this5.ua_id
                };
                _context4.next = 4;
                return (0, _index.apiDelFinanceAddress)(req);

              case 4:
                _yield$apiDelFinanceA = _context4.sent;
                status = _yield$apiDelFinanceA.status;
                data = _yield$apiDelFinanceA.data;
                _this5.delLoading = false;

                if (status == 200) {
                  _this5.getAddress(_this5.chain_tag);

                  _this5.delVisible = false;
                  (0, _message.showMessage)({
                    message: _this5.translateTitle("\u5220\u9664\u6210\u529F"),
                    type: "success"
                  });
                }

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    onModify: function onModify() {
      this.modifyVisible = true; // this.selectChange(this.ua_id);

      this.new_bak = this.addressData.bak;
    },
    onDelete: function onDelete() {
      this.delVisible = true;
      this.isModify = false;
    },
    onChainClick: function onChainClick(item) {
      this.acitiveChain = item;
    },
    getStaticChainInfo: function getStaticChainInfo() {
      var _this6 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this6.coinInfo = [];
                _context5.next = 3;
                return (0, _settings.apiGetStaticTableInfo)(1).then(function (_ref) {
                  var data = _ref.data;
                  _this6.coinMaps = data;
                });

              case 3:
                _context5.next = 5;
                return (0, _settings.apiGetStaticTableInfo)(56).then(function (_ref2) {
                  var data = _ref2.data;
                  _this6.chainMap = data;
                });

              case 5:
                _context5.next = 7;
                return (0, _settings.apiGetStaticTableInfo)(57).then(function (_ref3) {
                  var data = _ref3.data;

                  for (var key in data) {
                    for (var item in _this6.chainMap) {
                      if (data[key].chain.toUpperCase() == _this6.chainMap[item].chain_tag.toUpperCase() && data[key].status == 1 && _this6.chainMap[item].status == 1) {
                        _this6.coinInfo.push({
                          label: data[key].chain.toUpperCase(),
                          value: data[key].coin_id,
                          rate_out: data[key].fee,
                          is_default: data[key].is_default,
                          chain_status: _this6.chainMap[item].status,
                          status: data[key].status,
                          minout: data[key].minout,
                          maxout: data[key].maxout
                        });
                      }
                    }
                  }
                });

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // 复制成功
    copySuccess: function copySuccess() {
      this.$message({
        message: this.translateTitle("复制成功"),
        type: "success"
      });
    },
    copyError: function copyError() {
      (0, _message.showMessage)({
        message: this.translateTitle("\u5185\u5BB9\u590D\u5236\u5931\u8D25")
      });
    },
    // 选择币种
    selectChange: function selectChange(val) {
      var _this7 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var chain_tag_temp, chain_tag_strings, req, _yield$apiGetFinanceA, status, data;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this7.item_id = val;
                _this7.data = _this7.coinData[val];
                chain_tag_temp = [];
                chain_tag_strings = ""; // if (!val) {

                _this7.coinInfoComputed.forEach(function (item) {
                  chain_tag_temp.push(item.value);
                });

                chain_tag_strings = chain_tag_temp.join(",");
                req = {
                  item_id: val,
                  chain_tag_list: chain_tag_strings
                };
                _this7.chainList = [];
                _this7.qrcodeList = [];
                _context6.next = 11;
                return (0, _index.apiGetFinanceAddressList)(req);

              case 11:
                _yield$apiGetFinanceA = _context6.sent;
                status = _yield$apiGetFinanceA.status;
                data = _yield$apiGetFinanceA.data;

                if (status == 200) {
                  _this7.pageLoading = false;
                  data.forEach(function (ele) {
                    ele.chain_tag = ele.chain_tag.toUpperCase();

                    _this7.chainList.push(ele);
                  });
                  _this7.active = _this7.chain_tag.toUpperCase();
                  chain_tag_temp.forEach(function (tag) {
                    _this7.addressList4Tag[tag.toLowerCase()] = [];
                    data.forEach(function (ele) {
                      if (tag == ele.chain_tag) {
                        _this7.addressList4Tag[tag.toLowerCase()].push(ele);
                      }
                    });
                  });
                  _this7.addressList = _this7.addressList4Tag[_this7.chain_tag.toLowerCase()];

                  if (!_this7.isModify) {
                    if (_this7.addressList4Tag[_this7.chain_tag.toLowerCase()].length > 0) {
                      _this7.addressData = _this7.addressList4Tag[_this7.chain_tag.toLowerCase()][0];
                      _this7.ua_id = _this7.addressData.ua_id;
                      _this7.addressActive = _this7.addressData.ua_id; // this.onAddressChange(this.ua_id);
                    } else {
                      _this7.addressList = [];
                      _this7.addressData = [];
                    }
                  } else {
                    _this7.onAddressChange(_this7.ua_id);
                  }
                }

                _this7.acitiveChain = 0;

              case 16:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    // 获取充币地址
    getAddress: function getAddress(val) {
      var _this8 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var item_id, params, chain_tag_temp, chain_tag_strings, _yield$apiGetFinanceA2, status, msg, data;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                // this.chain_tag = val;  //pangpang注释
                item_id = _this8.data.item_id;
                params = {
                  item_id: item_id
                }; // if (!this.data.itemDetail.multi_chain_status) {
                //   this.active = "";
                // } else {
                //   params.chain_tag_list = this.chain_tag;
                // }

                chain_tag_temp = [];
                chain_tag_strings = ""; // if (!val) {

                _this8.coinInfoComputed.forEach(function (item) {
                  chain_tag_temp.push(item.value);
                });

                chain_tag_strings = chain_tag_temp.join(",");
                params.chain_tag_list = chain_tag_strings;
                _context7.next = 9;
                return (0, _index.apiGetFinanceAddressList)(params);

              case 9:
                _yield$apiGetFinanceA2 = _context7.sent;
                status = _yield$apiGetFinanceA2.status;
                msg = _yield$apiGetFinanceA2.msg;
                data = _yield$apiGetFinanceA2.data;

                // apiGetFinanceAddressList(params).then(({ status, msg, data }) => {
                if (status === 200) {
                  // if (val) {                          //pangpang 注释
                  //   this.active = val.toUpperCase();
                  // }
                  _this8.active = _this8.chain_tag.toUpperCase();
                  chain_tag_temp.forEach(function (tag) {
                    _this8.addressList4Tag[tag.toLowerCase()] = [];
                    data.forEach(function (ele) {
                      if (tag.toLowerCase() == ele.chain_tag) {
                        _this8.addressList4Tag[tag.toLowerCase()].push(ele);
                      }
                    });
                  });
                  _this8.addressList = _this8.addressList4Tag[_this8.chain_tag.toLowerCase()];

                  if (!_this8.isModify) {
                    if (_this8.addressList4Tag[_this8.chain_tag.toLowerCase()].length > 0) {
                      _this8.addressData = _this8.addressList4Tag[_this8.chain_tag.toLowerCase()][0];
                      _this8.ua_id = _this8.addressData.ua_id;
                      _this8.addressActive = _this8.addressData.ua_id; // this.onAddressChange(this.ua_id);
                    } else {
                      _this8.addressList = [];
                      _this8.addressData = [];
                    }
                  } else {
                    _this8.onAddressChange(_this8.ua_id);
                  }

                  _this8.dialogVisible = true;
                } else {
                  (0, _message.showMessage)({
                    message: msg ? msg : status
                  });
                }

              case 14:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    }
  }
};
exports.default = _default;